<mat-expansion-panel #expansionPanel [expanded]="true" data-qa-id="an_fc_bl_expand"
    [togglePosition]="expansionTogglePosition" class="nova__expansion nova__expansion--margin">
    <mat-expansion-panel-header class="nova__expansion__header">
        <mat-panel-title class="flex-row justify-start items-center">
            <span>
                Billing Rates ({{billingRatesCount}})
            </span>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="panel-body">
        @if (deletedShiftDifferential) {
        <div class="delete_billing_rate_warning">
            <nova-banner data-qa-id="delete_billing_rate_warning" bannerType="warning"
                bannerMessage="Removing Billing Rates may have negative impacts on existing shifts; Shift visibility, ability to fill the shift, and the hourly rate displayed may be impacted.">
            </nova-banner>
        </div>
        }
        @if (isLoading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
        @if (billingRates$ | async; as billingRates) {
        <div class="flex-col panel-content bc__content">
            <div class="item-group-toolbar">
                @if (editable) {
                <button mat-stroked-button color="secondary" (click)="editProfession(null)"
                    data-qa-id="an_fc_bl_add_profession_button">ADD PROFESSION</button>
                }
                <div class="toolbar-buttons">
                    <span>{{ (lastModified | isValueEmpty) === false ? "Last modified: " +
                        formatDateString(lastModified) : ""}}</span>
                    <span class="inlie-controls">
                        <span class="facility-details-search-input">
                            <input class="search" type="text" placeholder="Search professions..."
                                [(ngModel)]="searchText" data-qa-id="an_fc_bl_search_input">
                            <button mat-flat-button color="primary" class="search-btn" data-qa-id="an_fc_bl_search_button">
                                <mat-icon>search</mat-icon>
                            </button>
                        </span>
                    </span>
                    <span class="inlie-controls">@if (editable) {
                        <button mat-stroked-button color="secondary" [disabled]="isLoading || !dataEdited"
                            (click)="undo()" data-qa-id="an_fc_bl_undo_button">UNDO CHANGES</button>
                        }</span>
                    <span class="inlie-controls">@if (editable) {
                        <button mat-flat-button color="primary" [disabled]="isLoading || hasRangeBillingErrors(billingRates)"
                             (click)="saveChanges(billingRates)" data-qa-id="an_fc_bl_save_button">SAVE
                            CHANGES</button>
                        }</span>
                </div>
            </div>
            <cdk-virtual-scroll-viewport itemSize="{{billingRatesCount}}" [ngStyle]="{'height': height }"
                class="viewport">
                @for (billingRate of billingRates; track billingRate) {
                <div class="item-group wrapper">
                    @if (searchText === null || searchText === '' ||
                    billingRate.facilityBillingRate.professionName?.toUpperCase().includes(searchText?.toUpperCase())) {
                    <mat-card appearance="outlined" class="flex-0 billing-card" data-qa-id="an_fc_bl_billing_card">
                        <mat-card-content>
                            <div class="flex-col">
                                <div class="flex-row flex-height-60 item-group">
                                    <span
                                        data-qa-id="an_fc_bl_profession_readonly"><strong>{{billingRate?.facilityBillingRate?.professionName}}</strong></span>
                                    @if (editable) {
                                    <span class="toolbar-buttons">
                                        <span>@if (billingRate?.facilityBillingRate?.professionId !== -1) {
                                            <mat-icon class="app-remove-button-cell action-icon" matTooltip="Edit"
                                                (click)="editProfession(billingRate.facilityBillingRate)"
                                                data-qa-id="an_fc_bl_card_edit_button">edit</mat-icon>
                                            }</span>
                                        <span><mat-icon class="app-remove-button-cell action-icon" matTooltip="Copy"
                                                data-qa-id="an_fc_bl_card_copy_button">file_copy</mat-icon></span>
                                        <span>@if (billingRate?.facilityBillingRate?.professionId !== -1) {
                                            <mat-icon class="app-remove-button-cell action-icon" matTooltip="Delete"
                                                (click)="removeBillingRate(billingRate?.facilityBillingRate?.id)"
                                                data-qa-id="an_fc_bl_card_delete_button">delete</mat-icon>
                                            }</span>
                                    </span>
                                    }
                                </div>
                                <div class="flex-row">
                                    <span class="flex-width-18">
                                        <div>&nbsp;</div>
                                        @for (expertise of billingRate.facilityBillingRate.expertises; track expertise) {
                                        <div data-qa-id="an_fc_bl_specialty_readonly">{{expertise.name}}</div>
                                        }
                                    </span>
                                    @if (!billingRate.facilityBillingRate.isRangeBilling) {
                                    <span style="text-align: center;">
                                        <div class="billing-table">
                                            <div class="billing-table-row">
                                                <div class="billing-table-col-extended billing-table-col-right">Shift Type
                                                </div>
                                                @if (!billingRate.facilityBillingRate.splitedHours) {
                                                <div class="billing-table-col">All Hours</div>
                                                }
                                                @if (billingRate.facilityBillingRate.splitedHours) {
                                                <div class="billing-table-col">8 Hours</div>
                                                }
                                                @if (billingRate.facilityBillingRate.splitedHours) {
                                                <div class="billing-table-col">10 Hours</div>
                                                }
                                                @if (billingRate.facilityBillingRate.splitedHours) {
                                                <div class="billing-table-col">12 Hours</div>
                                                }
                                                @if (editable) {
                                                <div class="billing-table-col"><a href="#"
                                                        data-qa-id="an_fc_bl_change_hours_link"
                                                        (click)="changeHoursType($event, billingRate)">{{billingRate.facilityBillingRate.splitedHours
                                                        ? 'Combine' : 'Split'}}</a></div>
                                                }
                                            </div>
                                            @for (shiftDifferential of billingRate.facilityBillingRate.shiftDifferentials;
                                            track shiftDifferential) {
                                            <div class="billing-table-row">
                                                @if (shiftDifferential.name === 'Default') {
                                                <div class="billing-table-col-extended billing-table-col-right billing-table-col-vcenter"
                                                    data-qa-id="an_fc_bl_shift_differential_name_readonly">
                                                    {{shiftDifferential.name}}
                                                </div>
                                                }
                                                @if (shiftDifferential.name !== 'Default') {
                                                <div class="billing-table-col-extended billing-table-col-right">
                                                    <mat-select [disabled]="!editable" multiple class="shift-type-select"
                                                        (selectionChange)="updateShiftDifferentials($event, shiftDifferential, billingRate.facilityBillingRate)"
                                                        [value]="getShiftDifferentials(shiftDifferential)"
                                                        data-qa-id="an_fc_bl_shift_differential_select">

                                                        @if(!isTypeChecked(billingRate.facilityBillingRate.shiftDifferentials,
                                                        shiftDifferential, facilityBillingRateType.day)) {
                                                        <mat-option value="{{facilityBillingRateType.day}}">Day</mat-option>
                                                        }
                                                        @if(!isTypeChecked(billingRate.facilityBillingRate.shiftDifferentials,
                                                        shiftDifferential, facilityBillingRateType.mid)) {
                                                        <mat-option value="{{facilityBillingRateType.mid}}">Mid</mat-option>
                                                        }
                                                        @if(!isTypeChecked(billingRate.facilityBillingRate.shiftDifferentials,
                                                        shiftDifferential, facilityBillingRateType.night)) {
                                                        <mat-option
                                                            value="{{facilityBillingRateType.night}}">Night</mat-option>
                                                        }
                                                        @if(!isTypeChecked(billingRate.facilityBillingRate.shiftDifferentials,
                                                        shiftDifferential, facilityBillingRateType.weekendDay)) {
                                                        <mat-option value="{{facilityBillingRateType.weekendDay}}">Weekend
                                                            Day</mat-option>
                                                        }
                                                        @if(!isTypeChecked(billingRate.facilityBillingRate.shiftDifferentials,
                                                        shiftDifferential, facilityBillingRateType.weekendMid)) {
                                                        <mat-option value="{{facilityBillingRateType.weekendMid}}">Weekend
                                                            Mid</mat-option>
                                                        }
                                                        @if(!isTypeChecked(billingRate.facilityBillingRate.shiftDifferentials,
                                                        shiftDifferential, facilityBillingRateType.weekendNight)) {
                                                        <mat-option value="{{facilityBillingRateType.weekendNight}}">Weekend
                                                            Night</mat-option>
                                                        }
                                                    </mat-select>
                                                </div>
                                                }
                                                <div class="billing-table-col">
                                                    @if(!billingRate.facilityBillingRate.splitedHours) {
                                                    <input [disabled]="!editable"
                                                        (keyup)="validateNumeric($event, 9999.99, true)"
                                                        [(ngModel)]="shiftDifferential.allHours"
                                                        [ngModelOptions]="{ updateOn: 'blur' }"
                                                        (ngModelChange)="updateOnBlur($event)" min="0" max="9999.99"
                                                        class="billing-hours" />
                                                    }
                                                </div>
                                                <div class="billing-table-col">
                                                    @if(billingRate.facilityBillingRate.splitedHours) {
                                                    <input [disabled]="!editable"
                                                        (keyup)="validateNumeric($event, 9999.99, true)"
                                                        [(ngModel)]="shiftDifferential.hours8"
                                                        [ngModelOptions]="{ updateOn: 'blur' }"
                                                        (ngModelChange)="updateOnBlur($event)" min="0" max="9999.99"
                                                        class="billing-hours" />
                                                    }
                                                </div>
                                                <div class="billing-table-col">
                                                    @if(billingRate.facilityBillingRate.splitedHours) {
                                                    <input [disabled]="!editable"
                                                        (keyup)="validateNumeric($event, 9999.99, true)"
                                                        [(ngModel)]="shiftDifferential.hours10"
                                                        [ngModelOptions]="{ updateOn: 'blur' }"
                                                        (ngModelChange)="updateOnBlur($event)" min="0" max="9999.99"
                                                        class="billing-hours" />
                                                    }
                                                </div>
                                                <div class="billing-table-col">@if
                                                    (billingRate.facilityBillingRate.splitedHours) {
                                                    <input [disabled]="!editable"
                                                        (keyup)="validateNumeric($event, 9999.99, true)"
                                                        [(ngModel)]="shiftDifferential.hours12"
                                                        [ngModelOptions]="{ updateOn: 'blur' }"
                                                        (ngModelChange)="updateOnBlur($event)" min="0" max="9999.99"
                                                        class="billing-hours" />
                                                    }
                                                </div>
                                                @if (editable) {
                                                <div class="billing-table-col-left billing-table-col-icon">@if
                                                    (shiftDifferential.name !== 'Default') {
                                                    <mat-icon
                                                        (click)="removeShiftDifferential(billingRate, shiftDifferential)"
                                                        class="app-remove-button-cell action-icon grid-icon"
                                                        matTooltip="Delete"
                                                        data-qa-id="delete_shift_differential">delete</mat-icon>
                                                    }&nbsp;
                                                </div>
                                                }
                                            </div>
                                            }
                                            @if (editable) {
                                            <div class="billing-table-row">
                                                <div class="billing-table-col-extended billing-table-col-right">
                                                    <a href="#" (click)="addShiftDifferential($event, billingRate)"
                                                        data-qa-id="an_fc_bl_add_shift_differential_link">Add Shift
                                                        Differential</a>
                                                </div>
                                                <div class="billing-table-col">&nbsp;</div>
                                                <div class="billing-table-col">&nbsp;</div>
                                            </div>
                                            }
                                        </div>
                                    </span>
                                    }
                                    @if (billingRate.facilityBillingRate.isRangeBilling) {
                                    <span class="flex-width-70" style="text-align: center;">
                                        <div class="billing-table">
                                            <div class="billing-table-row">
                                                <div
                                                    class="billing-table-col-extended billing-table-col-right billing-table-col-vcenter">
                                                    Range
                                                </div>
                                                <div class="billing-table-col">
                                                    <input type="number" class="billing-hours"
                                                        [(ngModel)]="billingRate.facilityBillingRate.rangeBillingMin"
                                                        placeholder="min" data-qa-id="an_fc_bl_range_min_input" />
                                                    @if
                                                    (hasRangeMinMaxError(billingRate.facilityBillingRate.rangeBillingMin)) {
                                                    <mat-error data-qa-id="an_fc_bl_range_min_error">Value must be between
                                                        {{minRangeValue}} - {{maxRangeValue}}</mat-error>
                                                    }
                                                </div>
                                                <div class="billing-table-col">
                                                    <input type="number" class="billing-hours"
                                                        [(ngModel)]="billingRate.facilityBillingRate.rangeBillingMax"
                                                        placeholder="max" data-qa-id="an_fc_bl_range_max_input" />
                                                    @if
                                                    (hasRangeMinMaxError(billingRate.facilityBillingRate.rangeBillingMax)) {
                                                    <mat-error data-qa-id="an_fc_bl_range_max_error">Value must be between
                                                        {{minRangeValue}} - {{maxRangeValue}}</mat-error>
                                                    }
                                                </div>
                                                @if (hasRangeBillingError(billingRate.facilityBillingRate.isRangeBilling,
                                                billingRate.facilityBillingRate.rangeBillingMin,
                                                billingRate.facilityBillingRate.rangeBillingMax)) {
                                                <mat-error data-qa-id="an_fc_bl_range_error">Max must be greater or equal to
                                                    min value.</mat-error>
                                                }
                                            </div>
                                        </div>
                                    </span>
                                    }
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    }
                </div>
                }
            </cdk-virtual-scroll-viewport>
        </div>
        }
    </div>

</mat-expansion-panel>
